import { ClientIntegration, SFOTSalesReportSettings } from 'store/clientIntegrations';
import { Transaction } from 'store/deliveryLog';

export interface DeliveryErrorOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  transaction?: Transaction | null;
}

export interface FiltersOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  flowsToFilter: string[];
  setFlowsToFilter: (flows: string[]) => void;
  deliveryTypesToFilter: string[];
  setDeliveryTypesToFilter: (deliveryTypes: string[]) => void;
  filterChips: string[];
  setFilterChips: (filterChips: string[]) => void;
  selectedStartDate: Date | null;
  selectedEndDate: Date | null;
  setSelectedStartDate: (startDate: Date | null) => void;
  setSelectedEndDate: (endDate: Date | null) => void;
  handleFilter: () => void;
}

export interface SalesReportOverlayProps {
  clientIntegration: ClientIntegration;
  downloadContentAsCSV: (content: (string | number)[][] | object[], fileName: string) => void;
  onClose: () => void;
  setErrorMessage: (message: string | null) => void;
}

export interface SFOTSalesReportOverlayProps {
  clientIntegration: ClientIntegration;
  onClose: () => void;
  setErrorMessage: (message: string | null) => void;
  sfotSalesReportSettings: SFOTSalesReportSettings;
}

export interface SettlementReportOverlayProps {
  clientIntegration: ClientIntegration;
  downloadContentAsCSV: (content: (string | number)[][] | object[], fileName: string) => void;
  isGlobalAdmin: boolean;
  onClose: () => void;
  setErrorMessage: (message: string | null) => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatOrderSummary = (data: any[]) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const grouped: Record<string, any> = {};

  data.forEach((item) => {
    if (!grouped[item.productId]) {
      grouped[item.productId] = {
        productName: item.productName,
        items: {},
        quantity: 0
      };
    }

    const priceTypeKey = item.priceTypeId;

    // Group priceTypes
    if (!grouped[item.productId].items[priceTypeKey]) {
      grouped[item.productId].items[priceTypeKey] = {
        priceTypeName: item.priceTypeName,
        price: item.priceTypePrice,
        feeAmount: item.productFee1Amount || 0,
        quantity: 0
      };
    }

    grouped[item.productId].items[priceTypeKey].quantity += 1;
    grouped[item.productId].quantity += 1;
  });

  // Convert items object → array
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return Object.values(grouped).map((product: any) => ({
    ...product,
    items: Object.values(product.items)
  }));
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSummary = (formattedData: any, taxAmountFromTx: number = 0) => {
  let itemsCount = 0;
  let subTotal = 0;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  formattedData.forEach((product: any) => {
    itemsCount += product.quantity;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    product.items.forEach((i: any) => {
      const fee = i.feeAmount || 0;
      subTotal += (i.price + fee) * i.quantity;
    });
  });

  const taxes = taxAmountFromTx;
  const total = subTotal + taxes;

  return { itemsCount, subTotal, taxes, total };
};
